import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { formService, JobApplication, ContactMessage } from '@/services/other-services'
import { toast } from 'sonner'

export function useCareer() {
    const queryClient = useQueryClient()

    const query = useQuery({
        queryKey: ['career-applications'],
        queryFn: formService.getApplications,
    })

    const updateStatusMutation = useMutation({
        mutationFn: ({ id, status }: { id: string; status: JobApplication['status'] }) =>
            formService.updateApplicationStatus(id, status),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['career-applications'] })
            toast.success('Başvuru durumu güncellendi')
        },
        onError: () => toast.error('Durum güncellenirken bir hata oluştu'),
    })

    const deleteMutation = useMutation({
        mutationFn: (id: string) => formService.deleteApplication(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['career-applications'] })
            toast.success('Başvuru silindi')
        },
        onError: () => toast.error('Başvuru silinirken bir hata oluştu'),
    })

    return {
        ...query,
        data: Array.isArray(query.data) ? query.data : (query.data as any)?.items || [],
        updateStatus: updateStatusMutation.mutateAsync,
        deleteApplication: deleteMutation.mutateAsync,
    }
}

export function useContact() {
    const queryClient = useQueryClient()

    const query = useQuery({
        queryKey: ['contact-messages'],
        queryFn: formService.getMessages,
    })

    const updateStatusMutation = useMutation({
        mutationFn: ({ id, status }: { id: string; status: ContactMessage['status'] }) =>
            formService.updateMessageStatus(id, status),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['contact-messages'] })
            toast.success('Mesaj durumu güncellendi')
        },
        onError: () => toast.error('Durum güncellenirken bir hata oluştu'),
    })

    const deleteMutation = useMutation({
        mutationFn: (id: string) => formService.deleteMessage(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['contact-messages'] })
            toast.success('Mesaj silindi')
        },
        onError: () => toast.error('Mesaj silinirken bir hata oluştu'),
    })

    return {
        ...query,
        data: Array.isArray(query.data) ? query.data : (query.data as any)?.items || [],
        updateStatus: updateStatusMutation.mutateAsync,
        deleteMessage: deleteMutation.mutateAsync,
    }
}
